<template>
    <v-carousel height="520" cycle show-arrows hide-delimiters>
        <template v-slot:prev="{ props }">
            <button @click="props.onClick">
                <ChevronLeft :size="50"></ChevronLeft>
            </button>
        </template>
        <template v-slot:next="{ props }">
            <button @click="props.onClick">
                <ChevronRight :size="50"></ChevronRight>
            </button>
        </template>
        <v-carousel-item
            v-for="(item, i) in items"
            :key="i"
            :src="item.src"
            class="align-center"
            cover
        >
            <div class="align-center" style="width: 100%; height: 100%">
                <div
                    class="screen-width column"
                    style="padding: 0px 80px; gap: 24px"
                    :style="{ color: item.mode == 0 ? 'white' : 'black' }"
                >
                    <p class="title" v-html="item.title"></p>
                    <p class="detail">{{ item.detail }}</p>
                    <a
                        :href="item.href"
                        class="go-button align-center"
                        :style="{
                            background: item.mode == 0 ? 'white' : 'black',
                            color: item.mode == 0 ? 'black' : 'white',
                        }"
                    >
                        자세히 보기
                    </a>
                </div>
            </div>
        </v-carousel-item>
    </v-carousel>
</template>

<script>
import { ref } from "vue";
import { Carousel } from "vue-carousel";

import ChevronLeft from "vue-material-design-icons/ChevronLeft.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";

export default {
    name: "image-slider",
    components: { Carousel, ChevronRight, ChevronLeft },
    setup() {
        const colors = ref([
            "indigo",
            "warning",
            "pink darken-2",
            "red lighten-1",
            "deep-purple accent-4",
        ]);
        //mode 0 : white, 1:black
        const items = ref([
            {
                src: require("@/assets/img/banner/banner_hds_elite.avif"),
                mode: "0",
                title: "HDS & Elite Ti <br> 화면 오버레이 데이터 편집 방법",
                detail: "데이터를 조작해보세요",
                href: "/solution/1",
            },
            {
                src: require("@/assets/img/banner/banner_gx1800.avif"),
                mode: "1",
                title: "통신장비 VHF 무선송수신기 <br> MMSI 입력방법",
                detail: "선박정보를 입력해보세요",
                href: "/solution/27",
            },
            {
                src: require("@/assets/img/banner/banner_eagle.avif"),
                mode: "0",
                title: "EAGLE, 어탐 물고기 심벌 표시 방법",
                detail: "물고기 심벌을 표시하세요",
                href: "/solution/56",
            },
        ]);

        return {
            colors,
            items,
        };
    },
};
</script>

<style scoped>
.material-design-icon__svg {
}
.title {
    font-weight: bold;
    font-size: 32px;
}
.detail {
    font-weight: 600;
    font-size: 16px;
}
.go-button {
    width: 100px;
    height: 40px;
    border-radius: 30px;
    font-weight: bold;
    font-size: 14px;
    margin-top: 16px;
}
</style>
